var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "material-symbols-light:post-outline"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4 20V4H20V20H4ZM18.23 16.654H5.77V18.462H18.23V16.654ZM5.77 15.769H18.23V13.962H5.77V15.769ZM5.77 12.846H18.23V5.77H5.77V12.847V12.846ZM5.77 12.846V5.77V12.847V12.846Z",
    fill: "#242424"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPost);
export default __webpack_public_path__ + "static/media/post.bc01c20a42cc5def34554767cc350aff.svg";
export { ForwardRef as ReactComponent };